import { Component, forwardRef, Inject, Input, OnInit } from '@angular/core';
import { NgbActiveModal }                               from '@ng-bootstrap/ng-bootstrap';
import { BlockUI, NgBlockUI }                           from 'ng-block-ui';
import { TranslateService }                             from '@ngx-translate/core';

import { CompanyMessagesModel }         from '../companies/models/company.messages';
import { CompanyService }               from '../companies/company.service';
import { CustomerModel }                from '../customers/models/customer';
import { InvoiceModel }                 from '../invoices/models/invoice';
import { MessagesService }              from '../messages/messages.service';
import { OnlinePaymentSmsRequestModel } from './types/online-payment.sms-request';
import { OnlinePaymentsService }        from './online-payments.service';

@Component({
  selector   : 'wor-online-payment-sms-request',
  template: require('./online-payment.sms-request.component.html')
})
export class OnlinePaymentSmsRequestComponent implements OnInit {
  @BlockUI('onlinePaymentSmsRequestBlock') block : NgBlockUI;

  @Input() private companyMessages : CompanyMessagesModel;
  @Input() private customer        : CustomerModel;
  @Input() private invoice         : InvoiceModel;

  sms: OnlinePaymentSmsRequestModel;

  constructor (
    public activeModal           : NgbActiveModal,
    public companyService        : CompanyService,
    private messagesService      : MessagesService,
    @Inject(forwardRef(() => OnlinePaymentsService))
    private onlinePaymentsService: OnlinePaymentsService,
    private translateService     : TranslateService
  ) {}

  ngOnInit () : void {
    this.sms = {
      body           : this.companyMessages.default_sms_payment_request,
      invoice_id     : this.invoice.id,
      phone_number   : this.customer.mobile,
      request_payment: true
    };
  }

  send () : void {
    this.block.start(this.translateService.instant('GENERAL_SPACE.MESSAGE.SENDING'));

    this.onlinePaymentsService.sendSmsPaymentRequest(this.sms)
    .then(() => {
      this.activeModal.close(this.invoice);
    })
    .catch(( err : any ) => {
      this.messagesService.error(err);
    })
    .finally(() => {
      this.block.stop();
    });
  };
}
